import ShareSquadflixForm from "../shareSquadflixForm/shareSquadflixForm";
import React, {useEffect, useState} from "react";
import {
    fetchEpisodeCallback,
    fetchFileSquadflixDetails, fetchMovieCallback, fetchSerieCallback,
} from "../../../cap17drive/api/cap17drive-api";
import {Spinner} from "../../../shared";
import auth from "../../../../utils/authentication";
import TmdbResultCard from "../../../cap17drive/tmdbResultCard/tmdbResultCard";
import EpisodeResultCard
    from "../../../cap17drive/movies/serieDetails/seasonDetails/episodeResultCard/episodeResultCard";

const ViewerSquadflixMenu = ({file, onClose}) => {

    const [fileDetails, setFileDetails] = useState(null);
    const [tmdbItem, setTmdbItem] = useState(null);
    const [episode, setEpisode] = useState(null);
    const [type, setType] = useState(undefined);

    const fetchCap17anFileDetails = () => {
        fetchFileSquadflixDetails(file.storeUrl).then(res => {
            setFileDetails(res);

            if (!res.shared_id || !res.shared) {
                return;
            }
            if (res.shared.episodeTitle !== null) {
                setType("episode");
                fetchSerieCallback(res.shared.tmdb_id, auth.currentUser.uid).then(res => {
                    setTmdbItem(res);
                });
                fetchEpisodeCallback(res.shared.tmdb_id, res.shared.seasonNumber, res.shared.episodeNumber, auth.currentUser.uid).then(res => {
                    setEpisode(res);
                });
            } else {
                setType("movie");
                fetchMovieCallback(res.shared.tmdb_id, auth.currentUser.uid).then(res => {
                    setTmdbItem(res);
                });
            }

        });
    }

    const navigateToMovie = () => {
        window.location.href = `/squadflix/movies/${tmdbItem.id}`;
    }

    const navigateToEpisode = () => {
        window.location.href = `/squadflix/series/${tmdbItem.id}/${episode.season_number}/${episode.episode_number}`;
    }

    useEffect(() => {
        if (!file?.storeUrl) {
            setFileDetails(null);
            return;
        }
        fetchCap17anFileDetails();
    }, [file]);

    const handleConfirmShare = () => {
        fetchCap17anFileDetails();
    }

    if (!fileDetails) {
        return (
            <div className="d-flex flex-row justify-content-center">
                <Spinner/>
            </div>)
    }

    if (!fileDetails.shared_id) {
        return (
            <ShareSquadflixForm file={file} onClose={onClose} onConfirmShare={handleConfirmShare}/>
        )
    }

    if (!tmdbItem || (type === "episode" && !episode)) {
        return (
            <div className="d-flex flex-row justify-content-center">
                <Spinner/>
            </div>)
    }

    return (
        <div>
            {type === "movie" ?
                <div>
                    <div className="d-flex justify-content-between align-items-center">
                        <h4 className="modal-title">{tmdbItem.title}</h4>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <hr/>
                    <TmdbResultCard onClick={navigateToMovie} props={tmdbItem}/>
                </div> :
                <div>
                    <div className="d-flex justify-content-between align-items-center">
                        <h4 className="modal-title">{tmdbItem.name}</h4>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <hr/>
                    <EpisodeResultCard customOnClick={navigateToEpisode} nextInfoText={"Ver"} nextEpisodeInfo
                                       episode={episode} showSpoiler={true} forceSmall/>
                </div>}
        </div>
    )
}

export default ViewerSquadflixMenu;
